<template>
  <div class="calico-navbar-page">
    <CalicoNavbar />
  </div>
</template>

<script>
import CalicoNavbar from "@/components/calico/navbar/index.vue";

export default {
  name: 'CalicoNavigationBarPage',
  components: {
    CalicoNavbar,
  },
  data() {
    return {
      searchQuery: "",
    };
  },
  methods: {
    handleToggleMenu() {
      console.log("Menu icon clicked!");
    },
  },
};
</script>

<style lang="scss">
.calico-navbar-page {
  width: 100%;
  height: 100vh;
  background: rgb(103, 100, 100);
}
</style>
